import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Formik } from 'formik';

import {
  SR_API_ACTION_APARTMENT_LOCATOR_UPDATE_LEAD_NOTES,
} from 'api/actionTypes';

import SrFormikField from 'client/components/SrFormikField';

import { createInitialValues } from 'client/helpers/formikHelpers';
import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';

@withApiState({
  updateLeadNotesApiState: {
    action: SR_API_ACTION_APARTMENT_LOCATOR_UPDATE_LEAD_NOTES,
  },
})
class SrAgentLeadApartmentLocatorNotes extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    updateLeadNotesApiState: PropTypes.object.isRequired,
    reloadTable: PropTypes.func.isRequired,
    lead: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      showSavingAnimation: false,
      notes: props.lead.apartmentLocatorNotes,
    };

    this._isUnmounting = false;
  }

  componentWillUnmount() {
    this._isUnmounting = true;
  }

  _onUpdateNotes = (apartmentLocatorNotes) => {
    this.setState({ notes: apartmentLocatorNotes });
  }

  _onSaveNotes = () => {
    const { dispatch, lead, reloadTable } = this.props;
    const { notes } = this.state;

    dispatch(postWithState, {
      action: SR_API_ACTION_APARTMENT_LOCATOR_UPDATE_LEAD_NOTES,
      payload: {
        renterUserId: lead.renterUserId,
        apartmentLocatorUserId: lead.apartmentLocatorUserId,
        apartmentLocatorNotes: notes,
      },
    }).then(() => {
      reloadTable();
      this.setState({ showSavingAnimation: true });
      setTimeout(() => {
        if (!this._isUnmounting) {
          this.setState({ showSavingAnimation: false });
        }
      }, 3000);
    });
  }

  render() {
    const {
      lead,
      updateLeadNotesApiState,
    } = this.props;
    const {
      showSavingAnimation,
    } = this.state;

    const initialValues = createInitialValues({
      formFields: [{
        id: 'apartmentLocatorNotes',
      }],
      defaultValues: lead,
    });
    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange={false}
        onSubmit={this._onUpdateForm}
        render={(formikBag) => {
          return (
            <form>
              <div className='fieldContainer notes'>
                <span className='title'>client notes</span>
                <SrFormikField
                  formField={{
                    id: 'apartmentLocatorNotes',
                    type: 'long_text',
                    properties: {
                      placeholder: 'Write notes here...',
                      onChange: (e) => {
                        const apartmentLocatorNotes = e.target.value;
                        formikBag.setFieldValue('apartmentLocatorNotes', apartmentLocatorNotes);
                        this._onUpdateNotes(apartmentLocatorNotes);
                      },
                    },
                  }}
                  formikBag={formikBag}
                />
              </div>
              {showSavingAnimation && !updateLeadNotesApiState.inProgress ? (
                <div
                  className='saveContainer'
                >
                  <span className='button white saved'>saved!</span>
                </div>
              ) : (
                <div
                  className='saveContainer'
                  onClick={this._onSaveNotes}
                >
                  <span
                    className={classnames(
                      'button white',
                      updateLeadNotesApiState.inProgress && 'saving'
                    )}
                  >
                    save notes
                  </span>
                </div>
              )}
            </form>
          );
        }}
      />
    );
  }
}

SrAgentLeadApartmentLocatorNotes.displayName = 'SrAgentLeadApartmentLocatorNotes';

export default SrAgentLeadApartmentLocatorNotes;
